const monitoring = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/index.vue')

const unit_doc = () => import(/* webpackPrefetch: true */ '@/views/private/unit/doc/index.vue')

const attendance = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/index.vue')

const overtime = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/index.vue')

const permission = () => import(/* webpackPrefetch: true */ '@/views/private/permission/index.vue')

const licensing = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/index.vue')

const report = () => import(/* webpackPrefetch: true */ '@/views/private/report/index.vue')

const salary = () => import(/* webpackPrefetch: true */ '@/views/private/salary/index.vue')

const config = () => import(/* webpackPrefetch: true */ '@/views/private/salary/config/index.vue')

const reimbursement = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/index.vue')

const reimbursement_config = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/config/index.vue')


// PINDAH DARI SETTING
const unit_position = () => import(/* webpackPrefetch: true */ '@/views/private/unit/position/index.vue')


const routes = [
  {
    path: "/monitoring",
    name: "Monitoring",
    component: monitoring,
    meta: {
      title: "Monitoring"
    }
  },

  {
    path: "/unit/position",
    name: "Struktur Jabatan",
    component: unit_position,
    meta: {
      title: "Struktur Jabatan"
    }
  },

  {
    path: "/unit/doc",
    name: "Dokumen Organisasi",
    component: unit_doc,
    meta: {
      title: "Dokumen Organisasi"
    }
  },

  {
    path: "/attendance",
    name: "Presensi Pegawai",
    component: attendance,
    meta: {
      title: "Presensi Pegawai"
    }
  },

  {
    path: "/overtime",
    name: "Lembur Pegawai",
    component: overtime,
    meta: {
      title: "Lembur Pegawai"
    }
  },

  {
    path: "/permission",
    name: "Perizinan Pegawai",
    component: permission,
    meta: {
      title: "Perizinan Pegawai"
    }
  },

  {
    path: "/licensing",
    name: "Cuti Pegawai",
    component: licensing,
    meta: {
      title: "Cuti Pegawai"
    }
  },

  {
    path: "/report",
    name: "Laporan Pegawai",
    component: report,
    meta: {
      title: "Laporan Pegawai"
    }
  },

  {
    path: "/salary",
    name: "Informasi Gaji",
    component: salary,
    meta: {
      title: "Informasi Gaji"
    }
  },

  {
    path: "/salconfig",
    name: "Konfigurasi Komponen",
    component: config,
    meta: {
      title: "Konfigurasi Komponen"
    }
  },

  {
    path: "/reimbursement",
    name: "Data Reimburse",
    component: reimbursement,
    meta: {
      title: "Data Reimburse"
    }
  },

  {
    path: "/reimbconfig",
    name: "Konfigurasi Komponen",
    component: reimbursement_config,
    meta: {
      title: "Konfigurasi Komponen"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})